import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import CommonFallback from '@/shared/components/CommonFallback'
import NettingUpdaterPage from '@/containers/OrganizationsManagement/NettingUpdater/NettingUpdaterPage'
import { setTarget, reset } from '@/containers/OrganizationsManagement/NettingUpdater/nettingUpdaterSlice'
import useAdditionalProductsTools from '../DevToolsNew/useAdditionalProductsTools'

const AdditionalProductNettingPage = () => {
  const dispatch = useDispatch()
  const { technicalName } = useParams()
  const { isLoading, nettingProductByTechnicalName } = useAdditionalProductsTools()
  const product = nettingProductByTechnicalName(technicalName)

  useEffect(() => {
    dispatch(reset())

    if (product) {
      dispatch(
        setTarget({
          isProduct: true,
          technicalName,
          name: product.name,
          netting_process_type: product.netting_process_type,
          netting_accepted_extensions: product.netting_accepted_extensions,
          netting_batches: product.netting_batches,
          integration_technical_name: technicalName,
        }),
      )
    }

    return () => {
      dispatch(setTarget(null))
    }
  }, [technicalName, product?.id])

  if (isLoading || !product) {
    return <CommonFallback />
  }

  return <NettingUpdaterPage />
}

export default AdditionalProductNettingPage
